/* eslint-disable no-multi-assign */

/* eslint-disable no-param-reassign */

export function hashCode(str: string): number {
  let hash = 0;
  let i;
  let chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i += 1) {
    chr = str.charCodeAt(i);
    hash = (hash * 31 + chr) % 2 ** 32;
  }
  return hash;
}

export function mulberry32(a: number) {
  return (): number => {
    let t = (a += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function seededRandom(seed: number, max = 1, min = 0): number {
  const mulberryRandom = mulberry32(seed);

  return min + mulberryRandom() * (max - min);
}
